<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-part"> </p>
<p class="toc-part"><a id="page_7"></a><a href="#/007_Part01#pt-1">L<span class="smallcaps">ONDON</span></a></p>
<p class="toc-part"><span href="#/055_Part02#pt-2" title="Link target outside of Sample">Z<span class="smallcaps">ULULAND</span></span></p>
<p class="toc-part"><span href="#/072_Part03#pt-3" title="Link target outside of Sample">D<span class="smallcaps">URBAN</span></span></p>
<p class="toc-part"><span href="#/090_Part04#pt-4" title="Link target outside of Sample">P<span class="smallcaps">ARADISE</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Contents.vue?36a6539d